import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Typography,
  Grid,
  TextField,
  OutlinedInput,
  Button,
} from "@mui/material";
import React from "react";
import style from "./style";
import { LoadingButton } from "@mui/lab";
import { useForm, Controller } from "react-hook-form";
import humbbleIcon from "../../../assets/AccountingModule/humbleicons_upload.svg";
import { computationTypeOptions, depreciationFrequencyOptions } from "../../../constants/data";

const BrandingPage = ({ loading, handleAddNewCustomer }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({});

  const onSubmit = (data) => {
    handleAddNewCustomer(data);
  };

  return (
    <>
      <Box px="15px" mt={2}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>Branding</Typography>
        </Box>
      </Box>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Box sx={{ ...style.container, }}>
              <Grid item xs={12} md={12}>
                <Box sx={{ ...style.fileBox, height: "100%" }}>
                  <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                    Organization Logo
                  </Typography>
                  <Box
                    sx={{
                      ...style.fileDropArea,
                      border: "2px dashed #ccc",
                      borderRadius: "8px !important",
                      p: 2,
                      minHeight: "76px",
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "white",
                      cursor: "pointer",
                      "&:hover": {
                        borderColor: "#28AA4A",
                      },
                    }}
                  >
                    <input
                      type="file"
                      id="quoteFileUpload"
                      style={{ display: "none" }}
                    />
                    <label
                      htmlFor="quoteFileUpload"
                      style={{
                        cursor: "pointer",
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column"
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", gap: 2, }}>
                        <Button
                          variant="contained"
                          component="span"
                          startIcon={
                            <Box
                              component="span"
                              sx={{ display: "flex", alignItems: "center" }}
                            >
                              <img
                                src={humbbleIcon}
                                alt="Upload"
                                style={{ width: "16px", height: "16px" }}
                              />
                            </Box>
                          }
                          sx={{
                            backgroundColor: "#28AA4A",
                            color: "white",
                            textTransform: "none",
                            borderRadius: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            "&:hover": {
                              backgroundColor: "#229A41",
                            },
                          }}
                        >
                        </Button>
                        <Typography sx={{ color: "#666", fontSize: "12px", fontWeight: "400" }}>
                          Upload Your Organization Logo
                        </Typography>
                      </Box>
                      {/* )} */}
                    </label>
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: "10px", color: "#666", mt: 1, textAlign: "center" }}>
                      Preferred Image Dimensions: 240 x 240 pixels @ 72 DPI <br />
                      Supported Files: jpg, jpeg, png, gif, bmp <br />
                      Maximum File Size: 1MB
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ ...style.container, }}>
              <Grid item xs={12} md={12}>
                <Box sx={{ ...style.fileBox, height: "100%" }}>
                  <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                    Organization Banner
                  </Typography>
                  <Box
                    sx={{
                      ...style.fileDropArea,
                      border: "2px dashed #ccc",
                      borderRadius: "8px !important",
                      p: 2,
                      minHeight: "76px",
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "white",
                      cursor: "pointer",
                      "&:hover": {
                        borderColor: "#28AA4A",
                      },
                    }}
                  >
                    <input
                      type="file"
                      id="quoteFileUpload"
                      style={{ display: "none" }}
                    />
                    <label
                      htmlFor="quoteFileUpload"
                      style={{
                        cursor: "pointer",
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column"
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", gap: 2, }}>
                        <Button
                          variant="contained"
                          component="span"
                          startIcon={
                            <Box
                              component="span"
                              sx={{ display: "flex", alignItems: "center" }}
                            >
                              <img
                                src={humbbleIcon}
                                alt="Upload"
                                style={{ width: "16px", height: "16px" }}
                              />
                            </Box>
                          }
                          sx={{
                            backgroundColor: "#28AA4A",
                            color: "white",
                            textTransform: "none",
                            borderRadius: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center", // <-- icon center
                            "&:hover": {
                              backgroundColor: "#229A41",
                            },
                          }}
                        >
                        </Button>
                        <Typography sx={{ color: "#666", fontSize: "12px", fontWeight: "400" }}>
                          Upload Your Organization Logo
                        </Typography>
                      </Box>
                      {/* )} */}
                    </label>
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: "10px", color: "#666", mt: 1, textAlign: "center" }}>
                      Preferred Image Dimensions: 1920 x 1080 pixels @ 72 DPI <br />
                      Supported Files: jpg, jpeg, png, gif, bmp <br />
                      Maximum File Size: 1MB
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Box>
          </Grid >
        </Grid >
      </form >
    </>
  );
};

export default BrandingPage;
